import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#607D8B",
      dark: "#455A64",
      light: "#CFD8DC",
    },
  },
  typography: {
    fontFamily: "JetBrains Mono",
  },
});
